import { Tabs, withStyles } from '@material-ui/core';

export default withStyles({
  root: {
    borderBottom: '1px solid #e8e8e8',
  },
})(Tabs);
